import React from 'react'
import './Footer.css'

export default function Footer() {
  return (
    <div className="footer">
      <h2 className="footer-text">Creado con ❤️ Edgar Favela</h2>
    </div>
  )
}
